import React, { useState, useEffect } from "react";
import { CartState, EDirection } from "../enums";
import eventService from "../../services/eventService";
import storageService, {
  COMBO_PATH_CONFIG_KEY,
} from "../../services/storageService";
import TrayComponent from "../trayComponent/tray.component";
import YourPresentationButtonComponent from "../yourPresentationButtonComponent/yourPresentationButton.component";

const PresentationCartApplication = () => {
  const [cartState, setCartState] = useState<CartState>(CartState.EMPTY);
  const [trayOpen, setTrayOpen] = useState<boolean>(false);
  const [presentationData, setPresentationData] = useState<any>(
    storageService.challengePresentationConfigs
  );
  const [enabled, setEnabled] = useState<boolean>(false);

  const disable = () => {
    setEnabled(false);
  };

  const enable = () => {
    setEnabled(true);
  };

  const openTray = () => {
    setTrayOpen(true);
  };

  const closeTray = () => {
    setTrayOpen(false);
  };

  const syncCart = () => {
    const currentModules = storageService._getFromSessionStorage(
      COMBO_PATH_CONFIG_KEY
    );
    setPresentationData(storageService.challengePresentationConfigs);
    setCartState(
      currentModules?.selectedModules.length > 0
        ? CartState.LISTING
        : CartState.EMPTY
    );
  };

  const moveSlide = (index: number, direction: EDirection) => {
    const newModules = [...presentationData.selectedModules];
    if (direction === EDirection.up && index !== 0) {
      [newModules[index - 1], newModules[index]] = [
        newModules[index],
        newModules[index - 1],
      ];
    } else if (
      direction === EDirection.down &&
      index !== presentationData.length - 1
    ) {
      [newModules[index + 1], newModules[index]] = [
        newModules[index],
        newModules[index + 1],
      ];
    }

    setPresentationData({
      ...presentationData,
      selectedModules: newModules,
    });
    storageService.challengePresentationConfigs = {
      ...presentationData,
      selectedModules: newModules,
      slideOrderModified: true,
    };

    window.dispatchEvent(new Event("comboPathStorageUpdated"));
  };

  const removeSlide = (index: number) => {
    const newModules = [...presentationData.selectedModules];

    newModules.splice(index, 1);
    storageService.challengePresentationConfigs = {
      ...presentationData,
      selectedModules: newModules,
      slideOrderModified: newModules.length === 0 ? false : true,
    };
    window.dispatchEvent(new Event("comboPathStorageUpdated"));
  };

  useEffect(() => {
    // sync cart on load
    syncCart();

    // listen for changes in the dom to selected items to trigger a sync
    window.addEventListener("comboPathStorageUpdated", syncCart);

    eventService.on("presentation-app:disable", disable);
    eventService.on("presentation-app:enable", enable);

    return () => {
      window.removeEventListener("presentationStorageUpdated", syncCart);
      eventService.off("presentation-app:disable", disable);
      eventService.off("presentation-app:enable", enable);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <div className="presentation-app">
      <YourPresentationButtonComponent
        count={presentationData?.selectedModules.length || 0}
        openTray={openTray}
        trayOpen={trayOpen}
      />
      <TrayComponent
        slides={presentationData?.selectedModules || []}
        closeTray={closeTray}
        cartState={cartState}
        open={trayOpen}
        moveSlide={moveSlide}
        removeSlide={removeSlide}
      />
    </div>
  );
};

export default PresentationCartApplication;
